import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import classNames from 'classnames';

import { Sizes } from '@ratehub/base-ui';
import { CompoundInterestCalculator, CalculatorWidths } from '@ratehub/calculators';

import PAGE_TEMPLATES from '../definitions/PageTemplates';
import AdvertisingDisclosure from './AdvertisingDisclosure';


function BankingCompoundInterestCalc({ disclaimer, showAdDisclosure, className, ...otherProps }) {
    return (
        <Container className={classNames(
            'rh-py-0_5 rh-px-0 rh-my-0',
            className,
        )}
        >
            <CompoundInterestCalculator {...otherProps} />

            <If condition={disclaimer}>
                <p className="rh-text-xs disclaimer">
                    {disclaimer}
                </p>
            </If>

            <If condition={showAdDisclosure}>
                <AdvertisingDisclosure
                    className="rh-display-block rh-mt-1 rh-ml-auto"
                    size="extra-small"
                />
            </If>
        </Container>
    );
}

BankingCompoundInterestCalc.propTypes = {
    showAdDisclosure: PropTypes.bool,
    disclaimer: PropTypes.string,
    className: PropTypes.string,
};

BankingCompoundInterestCalc.defaultProps = {
    showAdDisclosure: undefined,
    disclaimer: undefined,
    className: undefined,
};

const Container = styled.section`
    max-width: ${CalculatorWidths.SMALL};
    margin-right: auto;
    margin-left: auto;

    > .disclaimer {
        margin: 0;
        text-align: center;

        padding-top: ${Sizes.SPACING.HALF};
    }
`;

BankingCompoundInterestCalc.blockKey = 'rh/banking-compound-interest-calculator';
BankingCompoundInterestCalc.requiresLayoutRow = true;
BankingCompoundInterestCalc.hasHeading = false;
BankingCompoundInterestCalc.supportedPageTypes = [ PAGE_TEMPLATES.calculatorsBanking ];

export default BankingCompoundInterestCalc;
